module.exports = __webpack_public_path__ + "img/cc07795a0c8b0d0fdab1a3c36ca762be.png";